var render = function () {
  var _vm$shippingInfo, _vm$shippingInfo$hub, _vm$shippingInfo$hub$, _vm$logisticInfo, _vm$logisticInfo$logi, _vm$logisticInfo$logi2, _vm$logisticInfo2, _vm$logisticInfo2$log, _vm$logisticInfo3, _vm$logisticInfo4, _vm$logisticInfo4$pic, _vm$logisticInfo5, _vm$logisticInfo6, _vm$logisticInfo7, _vm$logisticInfo7$log, _vm$logisticInfo7$log2, _vm$logisticInfo8, _vm$logisticInfo9, _vm$logisticInfo9$sel, _vm$logisticInfo10, _vm$logisticInfo11, _vm$logisticInfo11$pi, _vm$logisticInfo12, _vm$logisticInfo12$lo, _vm$logisticInfo12$lo2, _vm$logisticInfo13, _vm$logisticInfo13$lo, _vm$logisticInfo13$lo2, _vm$logisticInfo14, _vm$logisticInfo15, _vm$logisticInfo15$lo, _vm$logisticInfo15$lo2, _vm$logisticInfo16, _vm$logisticInfo16$se, _vm$logisticInfo17, _vm$logisticInfo17$lo, _vm$logisticInfo17$lo2, _vm$shippingInfo2, _vm$shippingInfo2$sen, _vm$shippingInfo3, _vm$shippingInfo3$sen, _vm$shippingInfo4, _vm$shippingInfo4$sen, _vm$shippingInfo5, _vm$shippingInfo5$sen, _vm$logisticInfo18, _vm$shippingInfo6, _vm$shippingInfo6$rec, _vm$shippingInfo7, _vm$shippingInfo7$rec, _vm$shippingInfo8, _vm$shippingInfo9, _vm$shippingInfo10, _vm$shippingInfo10$re, _vm$shippingInfo11, _vm$shippingInfo11$pa, _vm$shippingInfo11$pa2, _vm$logisticInfo19, _vm$logisticInfo19$lo, _vm$logisticInfo19$lo2, _vm$logisticInfo20, _vm$logisticInfo21, _vm$logisticInfo21$lo, _vm$logisticInfo21$lo2, _vm$logisticInfo22, _vm$logisticInfo22$se, _vm$logisticInfo23, _vm$logisticInfo23$lo, _vm$logisticInfo23$lo2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-order"
  }, [_c('div', {
    staticClass: "flex items-center bg-neutral-700 py-10 px-40 stepper relative mdmax:px-4 mdmax:text-center mdmax:gap-2 mdmax:-mx-4 mdmax:py-6 mdmax:items-stretch"
  }, [_c('div', {
    staticClass: "flex-1 py-2 px-6 rounded bg-neutral-600 mdmax:pl-3 mdmax:pr-3",
    class: {
      arrow: !_vm.isMobile
    }
  }, [_c('p', {
    staticClass: "text-sm font-medium text-white"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.title')))]), _c('p', {
    staticClass: "text-xs text-white"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.desc')))])]), _c('div', {
    staticClass: "flex-1 py-2 pl-10 pr-6 bg-neutral-600 rounded mdmax:pl-3 mdmax:pr-3",
    class: {
      arrow: !_vm.isMobile
    }
  }, [_c('p', {
    staticClass: "text-sm font-medium text-white"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.title')))]), _c('p', {
    staticClass: "text-xs text-white"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepTwo.desc')))])]), _c('div', {
    staticClass: "flex-1 py-2 pl-10 pr-6 bg-primary-100 rounded mdmax:pl-3 mdmax:pr-3",
    class: {
      arrow: !_vm.isMobile
    }
  }, [_c('p', {
    staticClass: "text-sm font-medium "
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.title')))]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.desc')))])])]), _c('div', {
    staticClass: "flex items-stretch bg-white shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-1/2 shadow-border-r p-6 mdmax:w-full mdmax:px-4"
  }, [_c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.detail')))]), _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.shippingDestination')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s((_vm$shippingInfo = _vm.shippingInfo) === null || _vm$shippingInfo === void 0 ? void 0 : (_vm$shippingInfo$hub = _vm$shippingInfo.hub) === null || _vm$shippingInfo$hub === void 0 ? void 0 : (_vm$shippingInfo$hub$ = _vm$shippingInfo$hub.destination) === null || _vm$shippingInfo$hub$ === void 0 ? void 0 : _vm$shippingInfo$hub$.area_display))])]), _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.serviceType')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s((_vm$logisticInfo = _vm.logisticInfo) === null || _vm$logisticInfo === void 0 ? void 0 : (_vm$logisticInfo$logi = _vm$logisticInfo.logistic) === null || _vm$logisticInfo$logi === void 0 ? void 0 : (_vm$logisticInfo$logi2 = _vm$logisticInfo$logi.package) === null || _vm$logisticInfo$logi2 === void 0 ? void 0 : _vm$logisticInfo$logi2.name))])]), _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.logistic')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s((_vm$logisticInfo2 = _vm.logisticInfo) === null || _vm$logisticInfo2 === void 0 ? void 0 : (_vm$logisticInfo2$log = _vm$logisticInfo2.logistic) === null || _vm$logisticInfo2$log === void 0 ? void 0 : _vm$logisticInfo2$log.serviceName))])]), _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.goodsCategory')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.goodsCategory))])]), _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.weight')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.calculatedShippingWeight) + " kg")])]), (_vm$logisticInfo3 = _vm.logisticInfo) !== null && _vm$logisticInfo3 !== void 0 && _vm$logisticInfo3.pickup ? _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.pickupService')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s((_vm$logisticInfo4 = _vm.logisticInfo) === null || _vm$logisticInfo4 === void 0 ? void 0 : (_vm$logisticInfo4$pic = _vm$logisticInfo4.pickup) === null || _vm$logisticInfo4$pic === void 0 ? void 0 : _vm$logisticInfo4$pic.name))])]) : _vm._e(), (_vm$logisticInfo5 = _vm.logisticInfo) !== null && _vm$logisticInfo5 !== void 0 && _vm$logisticInfo5.pickup ? _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.pickupTime')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.pickupTime) + " WIB")])]) : _vm._e(), (_vm$logisticInfo6 = _vm.logisticInfo) !== null && _vm$logisticInfo6 !== void 0 && _vm$logisticInfo6.selectedPODService ? _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.pod')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.podExist')))])]) : _vm._e(), _vm.insurance ? _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.goodsValue')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.goodsValue)))])]) : _vm._e(), _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.shippingCost')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")((_vm$logisticInfo7 = _vm.logisticInfo) === null || _vm$logisticInfo7 === void 0 ? void 0 : (_vm$logisticInfo7$log = _vm$logisticInfo7.logistic) === null || _vm$logisticInfo7$log === void 0 ? void 0 : (_vm$logisticInfo7$log2 = _vm$logisticInfo7$log.package) === null || _vm$logisticInfo7$log2 === void 0 ? void 0 : _vm$logisticInfo7$log2.shipment_cost)))])]), (_vm$logisticInfo8 = _vm.logisticInfo) !== null && _vm$logisticInfo8 !== void 0 && _vm$logisticInfo8.selectedPODService ? _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.shippingCostPod')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")((_vm$logisticInfo9 = _vm.logisticInfo) === null || _vm$logisticInfo9 === void 0 ? void 0 : (_vm$logisticInfo9$sel = _vm$logisticInfo9.selectedPODService) === null || _vm$logisticInfo9$sel === void 0 ? void 0 : _vm$logisticInfo9$sel.shipment_cost)))])]) : _vm._e(), (_vm$logisticInfo10 = _vm.logisticInfo) !== null && _vm$logisticInfo10 !== void 0 && _vm$logisticInfo10.pickup ? _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.pickupCost')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")((_vm$logisticInfo11 = _vm.logisticInfo) === null || _vm$logisticInfo11 === void 0 ? void 0 : (_vm$logisticInfo11$pi = _vm$logisticInfo11.pickup) === null || _vm$logisticInfo11$pi === void 0 ? void 0 : _vm$logisticInfo11$pi.shipment_cost)))])]) : _vm._e(), (_vm$logisticInfo12 = _vm.logisticInfo) !== null && _vm$logisticInfo12 !== void 0 && (_vm$logisticInfo12$lo = _vm$logisticInfo12.logistic) !== null && _vm$logisticInfo12$lo !== void 0 && (_vm$logisticInfo12$lo2 = _vm$logisticInfo12$lo.package) !== null && _vm$logisticInfo12$lo2 !== void 0 && _vm$logisticInfo12$lo2.discount_amount ? _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.shippingCostDiscount')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")((_vm$logisticInfo13 = _vm.logisticInfo) === null || _vm$logisticInfo13 === void 0 ? void 0 : (_vm$logisticInfo13$lo = _vm$logisticInfo13.logistic) === null || _vm$logisticInfo13$lo === void 0 ? void 0 : (_vm$logisticInfo13$lo2 = _vm$logisticInfo13$lo.package) === null || _vm$logisticInfo13$lo2 === void 0 ? void 0 : _vm$logisticInfo13$lo2.discount_amount)))])]) : _vm._e(), _vm.insurance ? _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.insuranceCost')))]), _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.insuranceCost)))])]) : _vm._e(), _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [!_vm.selectedVoucher ? _c('div', [_c('button', {
    staticClass: "flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-primary-500 border border-primary-500 rounded-lg hover:bg-primary-50 transition-colors",
    on: {
      "click": _vm.openVoucherModal
    }
  }, [_c('svg', {
    staticClass: "h-4 w-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
    }
  })]), _vm._v(" Pilih Voucher ")])]) : _c('div', {
    staticClass: "flex items-center gap-2 flex-1"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('p', {
    staticClass: "text-sm font-medium text-gray-900"
  }, [_vm._v(_vm._s(_vm.selectedVoucher.name))]), _c('p', {
    staticClass: "text-xs text-green-600"
  }, [_vm._v("Diskon " + _vm._s(_vm.selectedVoucher.discount_percentage) + "%")])]), _c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('p', {
    staticClass: "text-sm text-green-600 font-medium"
  }, [_vm._v("-" + _vm._s(_vm._f("currencyFormat")(_vm.discountAmount)))]), _c('button', {
    staticClass: "text-red-500 hover:text-red-700",
    on: {
      "click": function click($event) {
        _vm.selectedVoucher = null;
      }
    }
  }, [_c('svg', {
    staticClass: "h-4 w-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M6 18L18 6M6 6l12 12"
    }
  })])])])])]), _c('div', {
    staticClass: "mb-6 flex justify-between items-center pb-2 border-b"
  }, [_c('p', {
    staticClass: "text-sm font-bold"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.totalCost')))]), _vm.selectedVoucher ? _c('p', {
    staticClass: "text-sm font-bold"
  }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(_vm.finalTotalCost)) + " ")]) : (_vm$logisticInfo14 = _vm.logisticInfo) !== null && _vm$logisticInfo14 !== void 0 && _vm$logisticInfo14.selectedPODService ? _c('p', {
    staticClass: "text-sm font-bold"
  }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(((_vm$logisticInfo15 = _vm.logisticInfo) === null || _vm$logisticInfo15 === void 0 ? void 0 : (_vm$logisticInfo15$lo = _vm$logisticInfo15.logistic) === null || _vm$logisticInfo15$lo === void 0 ? void 0 : (_vm$logisticInfo15$lo2 = _vm$logisticInfo15$lo.package) === null || _vm$logisticInfo15$lo2 === void 0 ? void 0 : _vm$logisticInfo15$lo2.final_cost) + ((_vm$logisticInfo16 = _vm.logisticInfo) === null || _vm$logisticInfo16 === void 0 ? void 0 : (_vm$logisticInfo16$se = _vm$logisticInfo16.selectedPODService) === null || _vm$logisticInfo16$se === void 0 ? void 0 : _vm$logisticInfo16$se.shipment_cost) + _vm.insuranceCost)) + " ")]) : _c('p', {
    staticClass: "text-sm font-bold"
  }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(((_vm$logisticInfo17 = _vm.logisticInfo) === null || _vm$logisticInfo17 === void 0 ? void 0 : (_vm$logisticInfo17$lo = _vm$logisticInfo17.logistic) === null || _vm$logisticInfo17$lo === void 0 ? void 0 : (_vm$logisticInfo17$lo2 = _vm$logisticInfo17$lo.package) === null || _vm$logisticInfo17$lo2 === void 0 ? void 0 : _vm$logisticInfo17$lo2.final_cost) + _vm.insuranceCost)) + " ")])])]), _c('div', {
    staticClass: "w-1/2 p-6 mdmax:w-full mdmax:px-4"
  }, [_c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.senderInformation')))]), _c('div', {
    staticClass: "border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6"
  }, [_c('p', {
    staticClass: "font-medium text-xs mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.senderAddress')))]), _c('p', {
    staticClass: "font-bold mb-1"
  }, [_vm._v(_vm._s((_vm$shippingInfo2 = _vm.shippingInfo) === null || _vm$shippingInfo2 === void 0 ? void 0 : (_vm$shippingInfo2$sen = _vm$shippingInfo2.sender) === null || _vm$shippingInfo2$sen === void 0 ? void 0 : _vm$shippingInfo2$sen.sender_name))]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s((_vm$shippingInfo3 = _vm.shippingInfo) === null || _vm$shippingInfo3 === void 0 ? void 0 : (_vm$shippingInfo3$sen = _vm$shippingInfo3.sender) === null || _vm$shippingInfo3$sen === void 0 ? void 0 : _vm$shippingInfo3$sen.address))]), (_vm$shippingInfo4 = _vm.shippingInfo) !== null && _vm$shippingInfo4 !== void 0 && (_vm$shippingInfo4$sen = _vm$shippingInfo4.sender) !== null && _vm$shippingInfo4$sen !== void 0 && _vm$shippingInfo4$sen.detail_address ? _c('p', {
    staticClass: "bg-white p-2 mt-4"
  }, [_c('span', {
    staticClass: "block text-xs font-medium mb-1 text-neutral-500"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.details')))]), _c('span', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s((_vm$shippingInfo5 = _vm.shippingInfo) === null || _vm$shippingInfo5 === void 0 ? void 0 : (_vm$shippingInfo5$sen = _vm$shippingInfo5.sender) === null || _vm$shippingInfo5$sen === void 0 ? void 0 : _vm$shippingInfo5$sen.detail_address))])]) : _vm._e()]), (_vm$logisticInfo18 = _vm.logisticInfo) !== null && _vm$logisticInfo18 !== void 0 && _vm$logisticInfo18.selectedPODService ? _c('div', {
    staticClass: "mb-6 flex items-center gap-4 w-full"
  }, [_c('div', {
    staticClass: "text-sm w-full p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700 rounded-md"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  }), _vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.podNote')) + " ")], 1)]) : _vm._e(), _c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.receiverInformation')))]), _c('div', {
    staticClass: "border border-neutral-300 p-4 bg-neutral-200 rounded-md mb-6"
  }, [_c('p', {
    staticClass: "font-medium text-xs mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.receiverAddress')))]), _c('p', {
    staticClass: "font-bold mb-1"
  }, [_vm._v(_vm._s((_vm$shippingInfo6 = _vm.shippingInfo) === null || _vm$shippingInfo6 === void 0 ? void 0 : (_vm$shippingInfo6$rec = _vm$shippingInfo6.receiver) === null || _vm$shippingInfo6$rec === void 0 ? void 0 : _vm$shippingInfo6$rec.name))]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s((_vm$shippingInfo7 = _vm.shippingInfo) === null || _vm$shippingInfo7 === void 0 ? void 0 : (_vm$shippingInfo7$rec = _vm$shippingInfo7.receiver) === null || _vm$shippingInfo7$rec === void 0 ? void 0 : _vm$shippingInfo7$rec.addressDetail) + ", " + _vm._s((_vm$shippingInfo8 = _vm.shippingInfo) === null || _vm$shippingInfo8 === void 0 ? void 0 : _vm$shippingInfo8.hub.destination.village) + ", " + _vm._s((_vm$shippingInfo9 = _vm.shippingInfo) === null || _vm$shippingInfo9 === void 0 ? void 0 : _vm$shippingInfo9.hub.destination.area_display) + ".")]), _c('div', {
    staticClass: "flex justify-between items-center mt-4"
  }, [_c('p', {
    staticClass: "text-xs font-medium"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepThree.itemWeight')))]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(_vm._s((_vm$shippingInfo10 = _vm.shippingInfo) === null || _vm$shippingInfo10 === void 0 ? void 0 : (_vm$shippingInfo10$re = _vm$shippingInfo10.receiver) === null || _vm$shippingInfo10$re === void 0 ? void 0 : _vm$shippingInfo10$re.weight) + " kg")])]), _vm.volumetricWeight > 0 ? _c('div', {
    staticClass: "flex justify-between items-center mt-2"
  }, [_c('p', {
    staticClass: "text-xs font-medium text-neutral-500"
  }, [_vm._v("Volume Paket (" + _vm._s((_vm$shippingInfo11 = _vm.shippingInfo) === null || _vm$shippingInfo11 === void 0 ? void 0 : (_vm$shippingInfo11$pa = _vm$shippingInfo11.package) === null || _vm$shippingInfo11$pa === void 0 ? void 0 : (_vm$shippingInfo11$pa2 = _vm$shippingInfo11$pa.dimension) === null || _vm$shippingInfo11$pa2 === void 0 ? void 0 : _vm$shippingInfo11$pa2.replace(/x/g, ' x ')) + " cm)")]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(_vm._s(_vm.volumetricWeight) + " kg")])]) : _vm._e()]), !_vm.user.is_upgraded ? _c('div', {
    staticClass: "flex gap-8 justify-center"
  }, [_c('div', {
    staticClass: "border rounded-md p-8 flex-1"
  }, [_c('label', {
    staticClass: "flex gap-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.paymentType,
      expression: "paymentType"
    }],
    attrs: {
      "type": "radio",
      "name": "paymentType",
      "id": "paymentType1",
      "value": "qris"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "qris")
    },
    on: {
      "change": function change($event) {
        _vm.paymentType = "qris";
      }
    }
  }), _c('img', {
    staticClass: "h-1/3 w-1/3",
    attrs: {
      "src": require("@/assets/images/icons/qris.svg")
    }
  })])]), _c('div', {
    staticClass: "border rounded-md p-8 flex-1"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.paymentType,
      expression: "paymentType"
    }],
    attrs: {
      "disabled": ((_vm$logisticInfo19 = _vm.logisticInfo) === null || _vm$logisticInfo19 === void 0 ? void 0 : (_vm$logisticInfo19$lo = _vm$logisticInfo19.logistic) === null || _vm$logisticInfo19$lo === void 0 ? void 0 : (_vm$logisticInfo19$lo2 = _vm$logisticInfo19$lo.package) === null || _vm$logisticInfo19$lo2 === void 0 ? void 0 : _vm$logisticInfo19$lo2.final_cost) + _vm.insuranceCost < 80000 || ((_vm$logisticInfo20 = _vm.logisticInfo) === null || _vm$logisticInfo20 === void 0 ? void 0 : _vm$logisticInfo20.selectedPODService) && ((_vm$logisticInfo21 = _vm.logisticInfo) === null || _vm$logisticInfo21 === void 0 ? void 0 : (_vm$logisticInfo21$lo = _vm$logisticInfo21.logistic) === null || _vm$logisticInfo21$lo === void 0 ? void 0 : (_vm$logisticInfo21$lo2 = _vm$logisticInfo21$lo.package) === null || _vm$logisticInfo21$lo2 === void 0 ? void 0 : _vm$logisticInfo21$lo2.final_cost) + ((_vm$logisticInfo22 = _vm.logisticInfo) === null || _vm$logisticInfo22 === void 0 ? void 0 : (_vm$logisticInfo22$se = _vm$logisticInfo22.selectedPODService) === null || _vm$logisticInfo22$se === void 0 ? void 0 : _vm$logisticInfo22$se.shipment_cost) + _vm.insuranceCost < 80000,
      "type": "radio",
      "name": "paymentType",
      "id": "paymentType2",
      "value": "transfer"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "transfer")
    },
    on: {
      "change": function change($event) {
        _vm.paymentType = "transfer";
      }
    }
  }), _vm._v(" Bank Transfer ")]), ((_vm$logisticInfo23 = _vm.logisticInfo) === null || _vm$logisticInfo23 === void 0 ? void 0 : (_vm$logisticInfo23$lo = _vm$logisticInfo23.logistic) === null || _vm$logisticInfo23$lo === void 0 ? void 0 : (_vm$logisticInfo23$lo2 = _vm$logisticInfo23$lo.package) === null || _vm$logisticInfo23$lo2 === void 0 ? void 0 : _vm$logisticInfo23$lo2.final_cost) + _vm.insuranceCost < 80000 ? _c('p', {
    staticClass: "text-red-500 text-xs"
  }, [_vm._v(" To use this payment, the minimum payment is IDR 80.000 ")]) : _vm._e()])]) : _vm._e()])]), _c('div', {
    staticClass: "flex items-center p-6 justify-end bg-white gap-4 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "mdmax:order-2"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.createOrder.stepThree.back'),
      "type": "secondary"
    },
    on: {
      "action": function action($event) {
        return _vm.goBack('logistic');
      }
    }
  })], 1), _c('div', {
    staticClass: "mdmax:order-1"
  }, [_c('Button', {
    attrs: {
      "disabled": !_vm.user.is_upgraded && !_vm.paymentType || _vm.isLionParcelMissingCoord,
      "buttonText": _vm.$t('order.createOrder.stepThree.pay'),
      "type": "primary"
    },
    on: {
      "action": function action($event) {
        _vm.user.is_upgraded ? _vm.confirmationOrder() : _vm.submitOrder();
      }
    }
  })], 1), _c('div', {
    staticClass: "mdmax:order-1"
  }, [_c('Button', {
    attrs: {
      "disabled": !_vm.user.is_upgraded && !_vm.paymentType || _vm.isLionParcelMissingCoord,
      "buttonText": _vm.$t('order.createOrder.stepThree.draft'),
      "type": "primary"
    },
    on: {
      "action": function action($event) {
        return _vm.saveDraft();
      }
    }
  })], 1)]), _vm.showConfirmModal ? _c('div', {
    staticClass: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  }, [_c('div', {
    staticClass: "bg-white rounded-lg shadow-lg p-6 w-96"
  }, [_c('h2', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v("Konfirmasi Pembayaran")]), _c('p', {
    staticClass: "text-sm mb-6"
  }, [_vm._v("Apakah anda ingin melanjutkan proses pembayaran?")]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded bg-gray-300 hover:bg-gray-400",
    on: {
      "click": _vm.cancelVIPPayment
    }
  }, [_vm._v("Batal")]), _c('button', {
    staticClass: "px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700",
    on: {
      "click": _vm.confirmVIPPayment
    }
  }, [_vm._v("Ya, Bayar")])])])]) : _vm._e(), _vm.showNotifyModal ? _c('div', {
    staticClass: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  }, [_c('div', {
    staticClass: "bg-white rounded-lg shadow-lg p-6 w-96"
  }, [_c('h2', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v("Berhasil Dipesan")]), _c('p', {
    staticClass: "text-sm mb-6"
  }, [_vm._v("Pembayaran ini tercatat di Invoice Pembayaran")]), _c('div', {
    staticClass: "flex justify-center gap-4"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700",
    on: {
      "click": _vm.confirmNotifyPayment
    }
  }, [_vm._v("OK")])])])]) : _vm._e(), _vm.showVoucherModal ? _c('div', {
    staticClass: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeVoucherModal.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "bg-white rounded-lg shadow-xl w-full max-w-md flex flex-col",
    staticStyle: {
      "max-height": "600px"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center px-5 py-4 border-b bg-white rounded-t-lg flex-shrink-0"
  }, [_c('h2', {
    staticClass: "text-lg font-bold text-gray-800"
  }, [_vm._v("Pilih Voucher")]), _c('button', {
    staticClass: "text-gray-400 hover:text-gray-700 transition-colors p-1",
    on: {
      "click": _vm.closeVoucherModal
    }
  }, [_c('svg', {
    staticClass: "h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M6 18L18 6M6 6l12 12"
    }
  })])])]), _c('div', {
    staticClass: "overflow-y-auto flex-1 p-4",
    staticStyle: {
      "min-height": "0"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.voucherSearchQuery,
      expression: "voucherSearchQuery"
    }],
    staticClass: "w-full px-4 py-2 pl-10 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent",
    attrs: {
      "type": "text",
      "placeholder": "Cari kode voucher..."
    },
    domProps: {
      "value": _vm.voucherSearchQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.voucherSearchQuery = $event.target.value;
      }, _vm.searchVouchers]
    }
  }), _c('svg', {
    staticClass: "absolute left-3 top-2.5 h-5 w-5 text-gray-400",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    }
  })])])]), _vm.vouchers.length === 0 ? _c('div', {
    staticClass: "text-center py-8 text-gray-500"
  }, [_c('svg', {
    staticClass: "h-16 w-16 mx-auto mb-4 text-gray-300",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
    }
  })]), _c('p', {
    staticClass: "text-lg font-medium"
  }, [_vm._v("Tidak ada voucher tersedia")]), _c('p', {
    staticClass: "text-sm mt-2"
  }, [_vm._v("Voucher akan muncul di sini ketika tersedia")])]) : _c('div', {
    staticClass: "space-y-3"
  }, _vm._l(_vm.vouchers, function (voucher) {
    var _vm$selectedVoucher;

    return _c('div', {
      key: voucher.id,
      staticClass: "bg-white border border-gray-200 rounded-lg p-3 cursor-pointer transition-all hover:border-primary-400 hover:shadow-sm",
      class: {
        'border-primary-500 bg-primary-50': ((_vm$selectedVoucher = _vm.selectedVoucher) === null || _vm$selectedVoucher === void 0 ? void 0 : _vm$selectedVoucher.id) === voucher.id
      },
      on: {
        "click": function click($event) {
          return _vm.selectVoucher(voucher);
        }
      }
    }, [_c('div', {
      staticClass: "flex items-start gap-3"
    }, [_c('div', {
      staticClass: "flex-shrink-0"
    }, [_c('div', {
      staticClass: "w-10 h-10 bg-cyan-100 rounded flex items-center justify-center overflow-hidden"
    }, [voucher.delivery_service && voucher.delivery_service.logo ? _c('img', {
      staticClass: "w-full h-full object-contain",
      attrs: {
        "src": voucher.delivery_service.logo,
        "alt": voucher.delivery_service.name
      },
      on: {
        "error": function error($event) {
          $event.target.style.display = 'none';
        }
      }
    }) : _c('svg', {
      staticClass: "h-5 w-5 text-cyan-500",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
      }
    })])])]), _c('div', {
      staticClass: "flex-1 min-w-0"
    }, [_c('h3', {
      staticClass: "font-semibold text-base text-gray-900 mb-1"
    }, [_vm._v(_vm._s(voucher.name))]), voucher.delivery_service ? _c('p', {
      staticClass: "text-xs text-gray-600 mb-2 line-clamp-2"
    }, [_vm._v(" " + _vm._s(voucher.delivery_service.name) + " ")]) : _vm._e(), _c('div', {
      staticClass: "flex items-center gap-2 text-xs text-gray-500 mb-2"
    }, [_c('span', [_vm._v("Kode: " + _vm._s(voucher.voucher_code))]), _c('span', [_vm._v("•")]), _c('span', [_vm._v("Berlaku hingga: " + _vm._s(_vm.formatDate(voucher.end_date)))])]), _c('div', {
      staticClass: "flex items-center gap-2"
    }, [_c('span', {
      staticClass: "inline-block px-2 py-1 bg-green-100 text-green-700 text-xs font-medium rounded"
    }, [_vm._v(" Diskon " + _vm._s(voucher.discount_percentage) + "% ")]), _c('span', {
      staticClass: "inline-block px-2 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded"
    }, [_vm._v(" Sisa kuota: " + _vm._s(voucher.available_quota) + " ")])])])])]);
  }), 0)])])]) : _vm._e(), _vm.showMapModal ? _c('div', {
    staticClass: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        !_vm.isLionParcelMissingCoord ? _vm.showMapModal = false : null;
      }
    }
  }, [_c('div', {
    staticClass: "bg-white rounded-lg shadow-xl w-full max-w-2xl flex flex-col",
    staticStyle: {
      "max-height": "90vh"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center px-5 py-4 border-b bg-white rounded-t-lg"
  }, [_c('h2', {
    staticClass: "text-lg font-bold text-gray-800"
  }, [_vm._v("Lokasi Penjemputan")]), !_vm.isLionParcelMissingCoord ? _c('button', {
    staticClass: "text-gray-400 hover:text-gray-700 transition-colors p-1",
    on: {
      "click": function click($event) {
        _vm.showMapModal = false;
      }
    }
  }, [_c('svg', {
    staticClass: "h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M6 18L18 6M6 6l12 12"
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "overflow-y-auto flex-1 p-6 relative"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "absolute top-2 left-2 right-2 z-10"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.placeSearch,
      expression: "placeSearch"
    }],
    staticClass: "w-full px-4 py-2 pr-10 rounded-lg border border-neutral-300 bg-white shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('address.add.searchLocation') || 'Cari lokasi...'
    },
    domProps: {
      "value": _vm.placeSearch
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.placeSearch = $event.target.value;
      }, _vm.searchPlaces],
      "focus": function focus($event) {
        _vm.showPlaceSuggestions = true;
      }
    }
  }), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search', {
    staticClass: "w-5 h-5 text-neutral-400"
  })], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showPlaceSuggestions && _vm.placeSuggestions.length > 0 ? _c('div', {
    staticClass: "absolute top-full mt-1 w-full bg-white rounded-lg shadow-lg border border-neutral-200 max-h-60 overflow-y-auto z-50"
  }, _vm._l(_vm.placeSuggestions, function (place, index) {
    return _c('div', {
      key: index,
      staticClass: "px-4 py-3 hover:bg-neutral-50 cursor-pointer border-b border-neutral-100 last:border-b-0",
      on: {
        "click": function click($event) {
          return _vm.selectPlace(place);
        }
      }
    }, [_c('div', {
      staticClass: "text-sm font-medium text-neutral-900"
    }, [_vm._v(_vm._s(place.description))])]);
  }), 0) : _vm._e()])], 1)]), _c('GmapMap', {
    staticClass: "w-full h-96 rounded-lg overflow-hidden border border-neutral-300",
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "map-type-id": "roadmap",
      "options": {
        mapTypeControl: true,
        streetViewControl: false,
        fullscreenControl: true
      }
    },
    on: {
      "click": _vm.updateMarkerPosition
    }
  }, [_c('GmapMarker', {
    attrs: {
      "position": _vm.mapCenter,
      "draggable": true
    },
    on: {
      "dragend": _vm.updateMarkerPosition
    }
  })], 1), _c('button', {
    staticClass: "mt-4 w-full flex items-center justify-center gap-2 text-white px-4 py-3 rounded-lg shadow-lg font-bold transition-colors disabled:opacity-70",
    staticStyle: {
      "background-color": "#61d7d0"
    },
    attrs: {
      "disabled": _vm.isConfirmingLocation
    },
    on: {
      "click": _vm.confirmLocation
    }
  }, [!_vm.isConfirmingLocation ? _c('svg', {
    staticClass: "h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    }
  })]) : _c('svg', {
    staticClass: "animate-spin h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "4"
    }
  }), _c('path', {
    staticClass: "opacity-75",
    attrs: {
      "fill": "currentColor",
      "d": "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }
  })]), _vm._v(" " + _vm._s(_vm.isConfirmingLocation ? _vm.$t('address.add.loading') || 'Loading...' : _vm.$t('address.add.selectLocation') || 'Pilih Lokasi') + " ")]), _c('div', {
    staticClass: "mt-2 text-sm text-neutral-600 text-center"
  }, [_c('span', {
    staticClass: "font-medium"
  }, [_vm._v(_vm._s(_vm.$t('address.add.coordinates') || 'Koordinat') + ":")]), _vm._v(" " + _vm._s(_vm.mapCenter.lat.toFixed(6)) + ", " + _vm._s(_vm.mapCenter.lng.toFixed(6)) + " ")])], 1)])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }